/* global axios */

import ApiClient from './ApiClient';

class ClientelingTasksAPI extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return super.create({ clienteling_task: data });
  }

  update(taskId, data) {
    return super.update(taskId, { clienteling_task: data });
  }
}

export default new ClientelingTasksAPI();
